import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "table table-tenant" }
const _hoisted_7 = {
  key: 0,
  style: {"height":"300px"}
}
const _hoisted_8 = { colspan: "12" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }

import { ref, onMounted } from "vue";
import CreatePromotionKey from "../components/promotion/CreatePromotionKey.vue";
import EditPromotionKey from "../components/promotion/EditPromotionKey.vue";
import PromotionList from "../components/promotion/PromotionList.vue";
import SystemService from "../../system/services/SystemService";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import notification from "@/core/plugins/notification";


export default /*#__PURE__*/_defineComponent({
  __name: 'PromotionIndex',
  setup(__props) {

const isLoading = ref(false);
const statusLoading = ref(false);
const data = ref<any>([]);

const createPromotionRef = ref<any>(null);
const editPromotionRef = ref<any>(null);
const promotionListRef = ref<any>(null);

const showCreatePromotion = () => {
  createPromotionRef.value.show();
};

const showPromotionList = (item: any) => {
  promotionListRef.value.show(item);
};

const showEditPromotion = (item: any) => {
  editPromotionRef.value.show(item);
};

const updateStatus = async (item: any) => {
  statusLoading.value = true;
  try {
    await SystemService.updatePromotionStatus(item.id);
    notification.success();
  } catch (error) {
    console.error(error);
    notification.danger();
  } finally {
    statusLoading.value = false;
  }
};

const fetchData = async () => {
  isLoading.value = true;
  try {
    const res = await SystemService.queryPromotions();
    data.value = res.data;
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t("title.promotion")), 1),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_button, {
            type: "success",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showCreatePromotion())),
            plain: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.create")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.status")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.key")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.sites")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.updatedOn")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_8, [
                    _createVNode(ScaleLoader, { color: '#ffc730' })
                  ])
                ])
              ]))
            : (!isLoading.value && data.value.length == 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_switch, {
                          modelValue: item.is_published,
                          "onUpdate:modelValue": ($event: any) => ((item.is_published) = $event),
                          "active-color": "#13ce66",
                          "inactive-color": "#ff4949",
                          "active-value": 1,
                          "inactive-value": 0,
                          onClick: ($event: any) => (updateStatus(item))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.key), 1),
                      _createElementVNode("td", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.access_sites, (site, index) => {
                          return (_openBlock(), _createBlock(_component_el_tag, {
                            key: index,
                            plain: "",
                            class: "me-3",
                            type: "warning"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(site), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          type: "GMToneLiner",
                          "date-iso-string": item.updated_at
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          type: "GMToneLiner",
                          "date-iso-string": item.created_at
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_button, {
                          type: "warning",
                          onClick: ($event: any) => (showEditPromotion(item)),
                          plain: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.edit")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: ($event: any) => (showPromotionList(item)),
                          plain: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.view")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ]))
                  }), 128))
                ]))
        ])
      ])), [
        [_directive_loading, statusLoading.value]
      ])
    ]),
    _createVNode(CreatePromotionKey, {
      ref_key: "createPromotionRef",
      ref: createPromotionRef,
      onSubmit: fetchData
    }, null, 512),
    _createVNode(EditPromotionKey, {
      ref_key: "editPromotionRef",
      ref: editPromotionRef,
      onSubmit: fetchData
    }, null, 512),
    _createVNode(PromotionList, {
      ref_key: "promotionListRef",
      ref: promotionListRef
    }, null, 512)
  ], 64))
}
}

})